import { CodedProperty } from "sprint-common-web";

export type SearchAssetsSubtitleResponse = CodedProperty & {
    type: AssetDocumentSubtitleEmbeddingType;
    dynamicSubtitleType?: DynamicSubtitleType;
};

export enum AssetDocumentSubtitleEmbeddingType {
    Clean = 1,
    Embedded = 2,
    Dynamic = 3
}

export enum DynamicSubtitleType {
    Zip = 1,
    Dvb = 2,
    Srt = 3,
    Txt = 4,
    Vtt = 5,
    Ssa = 6,
    Scc = 7,
    VttIndexed = 8
}
